<script setup lang="ts">
import { ILMap } from '@caks/shared/modules/i'
import { onMounted, ref } from 'vue'

interface Props {
  points: Array<{
    lon: number
    lat: number
  }>
  coordinatesLon?:number
  coordinatesLat?:number
  desktop?: boolean
}

const props = withDefaults(defineProps<Props>(), { desktop: false })

const coords = ref<Array<number>>([])

onMounted(() => {
  if (!props.points.length) {
    coords.value = [45.039897, 41.962732]
  } else {
    coords.value.push(props.points[0].lon)
    coords.value.push(props.points[0].lat)
  }
})
</script>

<template>
  <div>
    <i-l-map
      :lon="coordinatesLon"
      :lat="coordinatesLat"
      :points="points"
      :desktop="desktop"
    />
  </div>
</template>
